// extracted by mini-css-extract-plugin
module.exports = {"advice":"StatementDescription_advice_1j2Ew"};